/**
 * Évite l’avertissement Chrome « Blocked aria-hidden on an element because its descendant retained focus »
 * lors de l’ouverture/fermeture des Dialog MUI.
 */
export function releaseFocus(): void {
  const el = document.activeElement;
  if (el instanceof HTMLElement) {
    el.blur();
  }
}

export const muiDialogTransitionProps = {
  onExiting: () => {
    releaseFocus();
  },
} as const;
